export const TAGGIN_EVENT_NAME = {
  GTM_POSPAID_BTN: 'postpaid_btn',
  META_POSPAID_BTN_TRACKCUSTOM: 'trackCustom',
  META_POSPAID_BTN: 'postpaidBtn',
  TIKTOK_POSPAID_BTN: 'postpaidBtn',
  GTM_VIEW_ITEMS_LIST: 'view_item_list',
  GTM_SELECT_ITEM: 'select_item',
  GTM_POSPAID_PHONE_VALIDATION: 'postpaid_phone_validation',
  GTM_POSPAID_NUMBER: 'postpaid_number',
  GTM_POSPAID_NUMBER_PIN: 'postpaid_number_pin',
  GTM_POSPAID_BIOMETRICS: 'postpaid_biometrics',
  GTM_POSPAID_IDENTIFY_VALIDATION: 'postpaid_documents',
  GTM_POSPAID_FRONT_PHOTO: 'postpaid_front_photo',
  GTM_POSPAID_BACK_PHOTO: 'postpaid_back_photo',
  GTM_POSPAID_PERSONAL_PHOTO: 'postpaid_personal_photo',
  GTM_POSPAID_PHOTO_VALIDATION: 'postpaid_photo_validation',
  GTM_POSPAID_FORM: 'postpaid_form',
  META_POSPAID_TRACKCUSTOM: 'trackCustom',
  META_POSPAID_FORM: 'postpaidForm',
  TIKTOK_POSPAID_FORM: 'postpaidForm',
  GTM_POSPAID_CREDIT: 'postpaid_credit',
  GTM_POSPAID_CREDIT_PIN: 'postpaid_credit_pin',
  META_POSPAID_CREDIT_PIN_TRACKCUSTOM: 'trackCustom',
  META_POSPAID_CREDIT_PIN: 'postpaidCreditPin',
  TIKTOK_POSPAID_CREDIT_PIN: 'postpaidCreditPin',
  GTM_ADD_TO_CARD: 'add_to_cart',
  META_ADD_TO_CARD_TRACK: 'track',
  META_ADD_TO_CARD: 'AddToCart',
  META_POSPAID_ADD_PLAN_TRACKCUSTOM: 'trackCustom',
  META_POSPAID_ADD_PLAN: 'postpaidAddPlan',
  TIKTOK_ADD_TO_CARD: 'AddToCart',
  TIKTOK_POSPAID_ADD_PLAN: 'postpaidAddPlan',
  GTM_BEGIN_CHECKOUT: 'begin_checkout',
  META_INITIATE_CHECKOUT_TRACK: 'track',
  META_INITIATE_CHECKOUT: 'InitiateCheckout',
  TIKTOK_INITIATE_CHECKOUT: 'InitiateCheckout',
  GTM_ADD_SHIPPING_INFO: 'add_shipping_info',
  META_ADD_SHIPPING_INFO_TRACK: 'track',
  META_ADD_SHIPPING_INFO: 'AddShippingInfo',
  TIKTOK_ADD_SHIPPING_INFO: 'AddShippingInfo',
  GTM_POSPAID_SELECT_PAYMENT: 'postpaid_select_payment',
  GTM_ADD_PAYMENT_INFO: 'add_payment_info',
  META_ADD_PAYMENT_INFO_TRACK: 'track',
  META_ADD_PAYMENT_INFO: 'AddPaymentInfo',
  META_POSPAID_PAYMENT_TRACKCUSTOM: 'trackCustom',
  META_POSPAID_PAYMENT: 'postpaidPayment',
  TIKTOK_ADD_PAYMENT_INFO: 'AddPaymentInfo',
  TIKTOK_POSPAID_PAYMENT: 'postpaidPayment',
  GTM_PURCHASE: 'purchase',
  META_PURCHASE_TRACK: 'track',
  META_PURCHASE: 'Purchase',
  META_POSPAID_PURCHASE_TRACKCUSTOM: 'trackCustom',
  META_POSPAID_PURCHASE: 'postpaidPurchase',
  TIKTOK_COMPLETE_PAYMENT: 'CompletePayment',
  TIKTOK_POSPAID_PURCHASE: 'postpaidPurchase',
  GTM_POSPAID_CONFIRM: 'postpaid_confirm',
  META_POSPAID_CONFIRM_TRACKCUSTOM: 'trackCustom',
  META_POSPAID_CONFIRM: 'postpaidConfirm',
  TIKTOK_POSPAID_CONFIRM: 'postpaidConfirm',
  TIKTOK_RECHARGE_CONFIRM: 'rechargeConfirm',
}

export const TAGGIN_EVENT_FUNNEL = {
  POSPAID_FUNNEL_BTN: 'Postpaid',
  FUNNEL_VIEW_ITEMS_LIST: 'Postpaid',
  FUNNEL_SELECT_ITEMS: 'Postpaid',
  POSPAID_FUNNEL_PHONE_VALIDATION: 'Postpaid',
  POSPAID_FUNNEL_NUMBER: 'Postpaid',
  POSPAID_FUNNEL_NUMBER_PIN: 'Postpaid',
  POSPAID_FUNNEL_BIOMETRICS: 'Postpaid',
  POSPAID_FUNNEL_IDENTIFY_VALIDATION: 'Postpaid',
  POSPAID_FUNNEL_FRONT_PHOTO: 'Postpaid',
  POSPAID_FUNNEL_BACK_PHOTO: 'Postpaid',
  POSPAID_FUNNEL_PERSONAL_PHOTO: 'Postpaid',
  POSPAID_FUNNEL_PHOTO_VALIDATION: 'Postpaid',
  POSPAID_FUNNEL_FORM: 'Postpaid',
  POSPAID_FUNNEL_CREDIT: 'Postpaid',
  POSPAID_FUNNEL_CREDIT_PIN: 'Postpaid',
  FUNNEL_ADD_TO_CARD: 'Postpaid',
  META_FUNNEL_ADD_TO_CARD: 'Postpaid',
  POSPAID_FUNNEL_ADD_TO_CARD: 'Postpaid',
  FUNNEL_BEGIN_CHECKOUT: 'Postpaid',
  META_FUNNEL_INITIATE_CHECKOUT: 'Postpaid',
  TIKTOK_FUNNEL_INITIATE_CHECKOUT: 'Postpaid',
  FUNNEL_ADD_SHIPPING_INFO: 'Postpaid',
  META_ADD_SHIPPING_INFO: 'Postpaid',
  TIKTOK_FUNNEL_ADD_SHIPPING_INFO: 'Postpaid',
  POSPAID_FUNNEL_SELECT_PAYMENT: 'Postpaid',
  FUNNEL_ADD_PAYMENT_INFO: 'Postpaid',
  META_FUNNEL_ADD_PAYMENT_INFO: 'Postpaid',
  TIKTOK_FUNNEL_ADD_PAYMENT_INFO: 'Postpaid',
  FUNNEL_PURCHASE: 'Postpaid',
  META_FUNNEL_PURCHASE: 'Postpaid',
  POSPAID_FUNNEL_META_PURCHASE: 'Postpaid',
  TIKTOK_FUNNEL_COMPLETE_PAYMENT: 'Postpaid',
  POSPAID_FUNNEL_TIKTOK_PURCHASE: 'Postpaid',
  POSPAID_FUNNEL_CONFIRM: 'Postpaid',
  POSPAID_FUNNEL_META_CONFIRM: 'Postpaid',
  POSPAID_FUNNEL_TIKTOK_CONFIRM: 'Postpaid',
  TIKTOK_FUNNEL_RECHARGE_CONFIRM: 'Postpaid',
}

export const TAGGIN_EVENT_SUBFUNNEL = {
  POSPAID_SUBFUNNEL_BTN: 'Botón Contratar Bait Pospago',
  SUBFUNNEL_VIEW_ITEMS_LIST: 'Visualización de opciones',
  SUBFUNNEL_SELECT_ITEMS: 'Click en opción',
  POSPAID_SUBFUNNEL_PHONE_VALIDATION: 'Validación de compatibilidad del equipo',
  POSPAID_SUBFUNNEL_NUMBER: 'Comparte tu número',
  POSPAID_SUBFUNNEL_NUMBER_PIN: 'Comparte tu número PIN',
  POSPAID_SUBFUNNEL_BIOMETRICS: 'Comenzar proceso de biométricos',
  POSPAID_SUBFUNNEL_IDENTIFY_VALIDATION: 'Comenzar captura de documentos',
  POSPAID_SUBFUNNEL_FRONT_PHOTO: 'Subir fotografia frontal',
  POSPAID_SUBFUNNEL_BACK_PHOTO: 'Subir fotografia trasera',
  POSPAID_SUBFUNNEL_PERSONAL_PHOTO: 'Subir fotografía personal',
  POSPAID_SUBFUNNEL_PHOTO_VALIDATION: 'Validación de fotos',
  POSPAID_SUBFUNNEL_FORM: 'Formulario',
  POSPAID_SUBFUNNEL_CREDIT: 'Consulta de historial en Buró de Crédito',
  POSPAID_SUBFUNNEL_CREDIT_PIN: 'Consulta de historial en Buró de Crédito - PIN',
  SUBFUNNEL_ADD_TO_CARD: 'Elige tu plan',
  SUBFUNNEL_BEGIN_CHECKOUT: 'Firma de contrato',
  SUBFUNNEL_ADD_SHIPPING_INFO: 'Firma de contrato - Continuar',
  POSPAID_SUBFUNNEL_SELECT_PAYMENT: 'Selección de pago',
  SUBFUNNEL_ADD_PAYMENT_INFO: 'Selección de pago',
  SUBFUNNEL_PURCHASE: 'Compra exitosa',
  POSPAID_SUBFUNNEL_CONFIRM: 'Selección de pago',
}

export const TAGGIN_CONTENT_TYPE = {
  META_ADD_TO_CARD: 'product',
  POSPAID_ADD_TO_CARD: 'product',
  META_INITIATE_CHECKOUT: 'product',
  TIKTOK_INITIATE_CHECKOUT: 'product',
  META_ADD_SHIPPING_INFO: 'product',
  TIKTOK_ADD_SHIPPING_INFO: 'product',
  META_ADD_PAYMENT_INFO: 'product',
  TIKTOK_ADD_PAYMENT_INFO: 'product',
  TIKTOK_COMPLETE_PAYMENT: 'product',
}

export const TAGGIN_EVENT_CATEGORY = {
  CATEGORY_NAME: 'pospago',
}

export const TAGGIN_EVENT_LIST = {
  LIST_NAME: 'ofertas pospago',
}

export const TAGGIN_EVENT_CURRENCY = 'MXN';
